import React from 'react';
const FilterByTypeSkeleton = () => (React.createElement("div", { className: "skeleton mx:-pw h:128 h:144:lg-up h:160:xl-up mb:28" }));
export default FilterByTypeSkeleton;
